import React, { useState } from 'react'
import { useTranslation } from "react-i18next"
import { DialogTermsCond, DialogPoliticyPrivacy } from '../../pures'
import './footer-login.pure.css'

const FooterLoginPure = (props) => {
  const { t } = useTranslation()
  const [modalTermsCond, setModalTermsCond] = useState(null)
  const [modalPolicityPrivacy, setModalPolicityPrivacy] = useState(null)

  const openModalTermsCond = (value) => {
    setModalTermsCond(value)
  }

  const openModalPolicityPrivacy = (value) => {
    setModalPolicityPrivacy(value)
  }

  return (
    <div className="general-container-simple-footer-login">
      <footer className={`simple-footer-login-container ${props.clientLogo && 'simple-footer-login-container-logo'}`}>
        <p className="simple-footer-login-sa">{t('simpleFooter.aServiceFromA3CM')}</p>
        <p style={{ cursor: 'pointer' }} onClick={() => { openModalPolicityPrivacy(true) }} className="simple-footer-login-ad-privacity">{t('simpleFooter.noticeOfprivacy')}</p>
        <p style={{ cursor: 'pointer' }} onClick={() => { openModalTermsCond(true) }} className="simple-footer-login-ad-privacity">{t('simpleFooter.termsAndConditios')}</p>
      </footer>

      <DialogPoliticyPrivacy
        modalPolicityPrivacy={modalPolicityPrivacy}
        openModalPolicityPrivacy={openModalPolicityPrivacy}
      />

      <DialogTermsCond
        modalTermsCond={modalTermsCond}
        openModalTermsCond={openModalTermsCond}
      />
    </div>
  )
}


export { FooterLoginPure as default }
